<template lang="pug">
    section#banner
        div.conteudoGratuito
            img(:src="require('@images/ead40/conteudoGratuito-v2.png')", alt="Conteúdo Gratuíto*")
        div.wrapper
            div.posgraduacao
                img(:src="require('@images/ead40/posgraduacao-emeducacao.png')", alt="Pós-Graduação em Educação à Distância 4.0")
            div.carlos
                img(:src="require('@images/ead40/carlos.png')", alt="")
            div.fael
                img(:src="require('@images/ead40/logo-fael.png')", alt="Centro Universitário UniFAEL")
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
